$('.single-slider .slide-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  arrows:true,
});


 $('.add').click(function () {
  if ($(this).prev().val() < 100) {
    $(this).prev().val(+$(this).prev().val() + 1);
  }
});
$('.sub').click(function () {
  if ($(this).next().val() > 1) {
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
  }
});
// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});

/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

});
/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");
});


/* Extra class "tab_last"
   to add border to right side
   of last tab */
$('ul.tabs li').last().addClass("tab_last");




if ($(window).width() > 640)
{
$('.customer-list').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 2,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
 }




//Product Thumbnail Slider
$('.product_thumbnail_img').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    }
  ]
});


// Related Product Slider
 setTimeout(function () {
  $('#related_product').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
    responsive: [
       {
      breakpoint: 1199,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
     },
      {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
    }, 2000);

// Product Page Description Tabs Plus\Minus Buttons 
$('.minus-icon').hide();
$('.product__info-container summary').click(function(){
    var tab_plus_btn = $(this).find('.plus-icon');
    var tab_minus_btn = $(this).find('.minus-icon');
        tab_plus_btn.toggle("accordion_hide");
        tab_minus_btn.toggle("accordion_show");
})


// Home Mobile Category Slider
$('.category_items_mobile').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
$(".accordion > li > h3").click(function(){

	if(false == $(this).next().is(':visible')) {
		$('.accordion .show_content').slideUp(300);
	}

	var classnm = $(this).parent('li').attr("class");
	// Line Added to remove the active class from all 'li'
	$('.accordion > li').removeClass('active');
	// Line Added to remove the blank attribute of class from all 'li'
	$('.accordion > li[class=""]').removeAttr('class');
	// Line Added to add the active class in current 'li'

	$(this).next().slideToggle(300);

	if(classnm == "undefined" || classnm == "" || classnm == undefined){
		$(this).parent('li').addClass('active');
	}
});
